import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MultiLingualHtmlEditorOptions, MultiLingualTextBoxOptions } from 'bnsights-control-library';
import { EmailHeaderAndFooterTemplateService } from '../../shared/Services/EmailHeaderAndFooterTemplateService.Service';
import { Router } from '@angular/router';
import { EmailHeaderAndFooterTemplate } from '../../shared/models/NotificationsModels/EmailHeaderAndFooterTemplate';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-add',
  templateUrl: './add.component.html'
})
export class AddComponent implements OnInit {

   //Add Model Controls
   AddForm = new FormGroup({});
   MultiLingualName:MultiLingualTextBoxOptions
   MultiLingualHtmlHeadTagAttributes:MultiLingualTextBoxOptions
   MultiLingualHeader:MultiLingualHtmlEditorOptions
   MultiLingualFooter:MultiLingualHtmlEditorOptions
   MultiLingualHtmlHeadSection:MultiLingualHtmlEditorOptions
   IsAddFormLoaded: boolean;
   language:string=""
   

  constructor(private pageInfoService:PageInfoService, private authService:AuthService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private emailHeaderAndFooterTemplateService: EmailHeaderAndFooterTemplateService,private router :Router) {
  }

  async ngOnInit(): Promise<void> {
    
    PageInfoService.PageTitle=""
    PageInfoService.PageBreadcrumbs=[
    ];

    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
      this.MultiLingualName = new MultiLingualTextBoxOptions();
      this.MultiLingualName.Name = "Name";
      this.MultiLingualName.ArabicLabelKey = "NameInArabic";
      this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
      this.MultiLingualName.IsRequired = true;
    this.MultiLingualName.Value = null;

      this.MultiLingualHtmlHeadTagAttributes = new MultiLingualTextBoxOptions();
      this.MultiLingualHtmlHeadTagAttributes.Name = "HtmlHeadTagAttributes";
      this.MultiLingualHtmlHeadTagAttributes.ArabicLabelKey =  "HtmlHeadTagAttributesInArabic";
      this.MultiLingualHtmlHeadTagAttributes.EnglishLabelKey = "HtmlHeadTagAttributesInEnglish";
      this.MultiLingualHtmlHeadTagAttributes.IsRequired = true;
      this.MultiLingualHtmlHeadTagAttributes.Value = null;
  
      this.MultiLingualHeader = new MultiLingualHtmlEditorOptions();
      this.MultiLingualHeader.Name = "Header";
      this.MultiLingualHeader.ArabicLabelKey =  "HeaderInArabic";
      this.MultiLingualHeader.EnglishLabelKey = "HeaderInEnglish";
      this.MultiLingualHeader.IsRequired = true;
      this.MultiLingualHeader.Value = null;

      this.MultiLingualFooter = new MultiLingualHtmlEditorOptions();
      this.MultiLingualFooter.Name = "Footer";
      this.MultiLingualFooter.ArabicLabelKey =  "FooterInArabic";
      this.MultiLingualFooter.EnglishLabelKey = "FooterInEnglish";
      this.MultiLingualFooter.IsRequired = true;
      this.MultiLingualFooter.Value = null;
  
      this.MultiLingualHtmlHeadSection = new MultiLingualHtmlEditorOptions();
      this.MultiLingualHtmlHeadSection.Name = "HtmlHeadSection";
    this.MultiLingualHtmlHeadSection.ArabicLabelKey =  "HTMLHeadSectionInArabic";
    this.MultiLingualHtmlHeadSection.EnglishLabelKey = "HTMLHeadSectionInEnglish";
      this.MultiLingualHtmlHeadSection.IsRequired = true;
      this.MultiLingualHtmlHeadSection.Value = null;
  
    setTimeout(() => {
      this.utilityService.stopBlockUI();
    }, 10);
    
  }

 
  

  addHeaderTemplate(){
    if (this.AddForm.invalid) {
      return;
    }
    else {
      this.utilityService.startBlockUI();
      let ResultModel = this.AddForm.value;
      let EmailHeaderAndFooterTemplateModel = new EmailHeaderAndFooterTemplate();
      EmailHeaderAndFooterTemplateModel.Name.English = ResultModel.Name.EnglishValue
      EmailHeaderAndFooterTemplateModel.Name.Arabic = ResultModel.Name.ArabicValue
      EmailHeaderAndFooterTemplateModel.Header.English = ResultModel.Header.EnglishHtmlEditorValue
      EmailHeaderAndFooterTemplateModel.Header.Arabic = ResultModel.Header.ArabicHtmlEditorValue
      EmailHeaderAndFooterTemplateModel.Footer.English = ResultModel.Footer.EnglishHtmlEditorValue
      EmailHeaderAndFooterTemplateModel.Footer.Arabic = ResultModel.Footer.ArabicHtmlEditorValue
      EmailHeaderAndFooterTemplateModel.HeadSection.English = ResultModel.HtmlHeadSection.EnglishHtmlEditorValue
      EmailHeaderAndFooterTemplateModel.HeadSection.Arabic = ResultModel.HtmlHeadSection.ArabicHtmlEditorValue
      EmailHeaderAndFooterTemplateModel.HeadTagAttributes.English = ResultModel.HtmlHeadTagAttributes.EnglishValue
      EmailHeaderAndFooterTemplateModel.HeadTagAttributes.Arabic = ResultModel.HtmlHeadTagAttributes.ArabicValue
      this.emailHeaderAndFooterTemplateService.AddEmailHeaderAndFooterTemplate( EmailHeaderAndFooterTemplateModel).subscribe((result) => {
        this.AddForm.reset()
        this.close()
      }, (error) => {
      })
    }
  }
  close(){
    this.router.navigate(['/Admin/Notifications/MasterLayouts']);
  }
}
